import "./Dashboard.scss";
import React, { useContext, useEffect, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";

import GLOBAL from "../../global";
import CONSTANT from "../../constants/Constant";
import routes from "../../constants/Routes";
import MainHeaderWrapper from "../shared/layout/HeadWrappers/MainHeaderWrapper";
import DashboardBody from "./DashboardBody";
import DashboardFooter from "../shared/layout/Footer";
import AppContext from "../../contexts/AppContext";
import {getNotificationData} from "./notification/business/services";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";
import AppLoading from "../shared/loading/AppLoading";
import ExamineticsDashboardBody from "./ExamineticsDashboardBody";
import {createWebRTCToken} from "../shared/MovementModal/Services/AssessementService";
import {toast} from "react-toastify";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

function Dashboard() {
    const { blockedUI, userInfo } = useContext(AppContext);
    const { EnableFysicalScore, IsPostureAnalyzeEnabled } = userInfo.Permissions;
    const emailAddress = (GLOBAL.USER_INFO && GLOBAL.USER_INFO["EmailAddress"]) || "";
    const [allNotifications, setAllNotifications] = useState([]);
    const [isLoadingNotification, setIsLoadingNotification] = useState(true);
    const [inviattionGId, setInviattionGId] = useState('');

    const location = useLocation();
    const history = useHistory();

    const { isAthleteEnabled, isExamineticsEnabled } = useTenantFeatures();

    const fetchNotificationData = async () => {
        if(!isLoadingNotification) {
            setIsLoadingNotification(true);
            setAllNotifications([]);
        }
        const prepareData = await getNotificationData(emailAddress);
        setAllNotifications(prepareData);
        setIsLoadingNotification(false);
    }

    useEffect(() => {
        const url = window.location.href;
        const params = new URLSearchParams(url.slice(url.indexOf('?')));
        const invGId = params.get('InvGId') || params.get('invgid');

        if (invGId && params.get('RA') === 'true') {
            setInviattionGId(invGId)
        }
    }, []);

    useEffect(() => {
        if (!isAthleteEnabled && !isExamineticsEnabled) {
            fetchNotificationData();
        } else {
            setIsLoadingNotification(false);
        }
    }, [isAthleteEnabled, isExamineticsEnabled, location.state?.refresh]);

    useEffect(() => {
        if (location.state?.refresh) {
            history.replace({ ...location, state: {} });
        }
    }, [location]);

    useEffect(() => {
        if (!inviattionGId) return;

        const createTokenAndRedirect = async () => {
            try {
                const response = await createWebRTCToken(inviattionGId);

                if (response?.success) {
                    const webRTCPortalUrl = response?.data?.WrtcUrl ?? "";
                    const token = response?.data?.Token ?? "";

                    if (webRTCPortalUrl && token) {
                        const url = window.location.href;
                        const params = new URLSearchParams(url.slice(url.indexOf('?')));
                        const qs = [`roomId=${token}`];
                        if (params.get('TestId')) qs.push(`TestId=${params.get('TestId')}`);
                        if (params.get('RA')) qs.push(`RA=${params.get('RA')}`);
                        if (params.get('BodyRegionIds')) qs.push(`BodyRegionIds=${params.get('BodyRegionIds')}`);

                        window.location.href = `${webRTCPortalUrl}/?roomId=${token}`;
                    }
                } else {
                    toast.error(response?.error || "Failed to create WebRTC token");
                }
            } catch (error) {
                toast.error("Unexpected error while creating WebRTC token");
                console.error(error);
            }
        };

        createTokenAndRedirect();
    }, [inviattionGId]);

    useEffect(() => {
        if (!inviattionGId && isAthleteEnabled) {
            return <Redirect to={routes.myAssessments + '/false'} />;
        }
    }, [!inviattionGId, isAthleteEnabled]);

    return (
        <div className="">
            <MainHeaderWrapper />
            {isLoadingNotification && (
                <div className="position-center">
                    <AppLoading/>
                </div>
            )}
            <React.Fragment>
                {!EnableFysicalScore && IsPostureAnalyzeEnabled && !isLoadingNotification && (
                    isExamineticsEnabled ? <ExamineticsDashboardBody /> : 
                    <DashboardBody 
                        isLoadingNotification={isLoadingNotification} 
                        allNotifications={allNotifications} 
                        fetchNotificationData={fetchNotificationData}
                    />
                )}
                {EnableFysicalScore && (
                    <React.Fragment>
                        <BodyWithTopMenu pageName={CONSTANT.PAGE_NAME.DASHBOARD} >
                            {(!blockedUI && !isLoadingNotification && !isExamineticsEnabled) &&
                                <DashboardBody
                                    isLoadingNotification={isLoadingNotification}
                                    allNotifications={allNotifications}
                                    fetchNotificationData={fetchNotificationData}
                                />
                            }
                            {(!blockedUI && isExamineticsEnabled) &&
                                <ExamineticsDashboardBody />
                            }

                        </BodyWithTopMenu>
                        <DashboardFooter/>
                    </React.Fragment>
                )}
            </React.Fragment>
        </div>
    );
}

export default Dashboard;
